export default {
    MORE: 'more',
    LESS: 'less',
};